import { NavLink, useNavigate } from 'react-router-dom';
import {
  Home, Users, Target, Rocket, ClipboardList,
  BarChart3, ChevronLeft, ChevronRight, LogOut
} from 'lucide-react';
import { useState } from 'react';

const navItems = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/audience-intelligence', label: 'Audience Intelligence', icon: Users },
  { to: '/priority-accounts', label: 'Priority Accounts', icon: Target },
  { to: '/campaigns', label: 'Campaign Execution', icon: Rocket },
  { to: '/leads', label: 'Leads Management', icon: ClipboardList },
  { to: '/analytics', label: 'Analytics', icon: BarChart3 },
];

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('oaa_user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('oaa_token');
    localStorage.removeItem('oaa_user');
    navigate('/login');
  };

  return (
    <aside
      data-testid="sidebar"
      className={`fixed left-0 top-0 h-screen bg-[#0A0A0A] flex flex-col z-50 transition-all duration-200 ${
        collapsed ? 'w-[60px]' : 'w-[220px]'
      }`}
    >
      {/* Logo */}
      <div className="flex items-center gap-2.5 px-4 h-[60px] border-b border-white/6">
        <div className="w-7 h-7 rounded-md bg-[#F66922] flex items-center justify-center flex-shrink-0">
          <span className="text-white text-[11px] font-black tracking-tight">O</span>
        </div>
        {!collapsed && (
          <span className="text-white font-bold text-[15px] tracking-tight">OASIS</span>
        )}
      </div>

      {/* Nav */}
      <nav className="flex-1 py-4 px-2 space-y-0.5 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            className={({ isActive }) =>
              `flex items-center gap-2.5 px-3 py-[9px] rounded-md text-[12.5px] font-medium transition-all ${
                isActive
                  ? 'text-white bg-white/10'
                  : 'text-neutral-500 hover:text-neutral-300 hover:bg-white/5'
              }`
            }
          >
            <item.icon className="w-4 h-4 flex-shrink-0" strokeWidth={1.8} />
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Collapse */}
      <button
        data-testid="sidebar-toggle"
        onClick={() => setCollapsed(!collapsed)}
        className="mx-2 mb-2 p-2 rounded-md text-neutral-600 hover:text-white hover:bg-white/5"
      >
        {collapsed ? <ChevronRight className="w-3.5 h-3.5" /> : <ChevronLeft className="w-3.5 h-3.5" />}
      </button>

      {/* User */}
      <div className="border-t border-white/6 px-3 py-3 flex items-center gap-2.5">
        <div className="w-7 h-7 rounded-full bg-neutral-800 flex items-center justify-center text-neutral-400 text-[10px] font-bold flex-shrink-0">
          {(user.name || 'A')[0]}
        </div>
        {!collapsed && (
          <div className="flex-1 min-w-0">
            <p className="text-neutral-300 text-[11px] font-medium truncate">{user.name || 'Admin'}</p>
            <p className="text-neutral-600 text-[9px] truncate">{user.email || ''}</p>
          </div>
        )}
        {!collapsed && (
          <button
            data-testid="logout-btn"
            onClick={handleLogout}
            className="text-neutral-600 hover:text-red-400"
          >
            <LogOut className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    </aside>
  );
}
